export const validateContact = e => {
  const regex = /^[0-9]$/ // Only allow numbers (0-9)

  const allowedBtns = [
    "Backspace",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
    "Alt",
    "Control",
    ".",
  ]

  // If the key pressed is not a number or if it's a letter, prevent it
  if (!regex.test(e.key) && !allowedBtns.includes(e.key)) {
    e.preventDefault()
  }
}

export const validateString = e => {
  const regex = /^[a-zA-Z\s]*$/ // Allow only alphabetic characters and spaces
  // If the key pressed is not alphabetic or space, prevent it
  if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
    e.preventDefault()
  }
}

export const sanitizeNumber = e => {
  const cleaned = e.target.value.replace(/\D/g, "") // remove non-digits
  if (cleaned !== e.target.value) {
    e.target.value = cleaned
    // also update your state properly
    handleSetData({ target: { name: e.target.name, value: cleaned } })
  }
}

export const rangesOverlap = (inA, outA, inB, outB) => {
  const start1 = toMinutes(inA),
    end1 = toMinutes(outA)
  const start2 = toMinutes(inB),
    end2 = toMinutes(outB)
  if (!start1 || !end1 || !start2 || !end2) return false
  return start1 < end2 && start2 < end1
}

export const toMinutes = time => {
  if (!time) return null
  const [h, m] = time.split(":").map(Number)
  return h * 60 + m
}
